// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"70687d63","275":"1545f31d","299":"63d0e782","524":"1545f31d","583":"47b07c92","664":"da70b9e9","667":"d11bb9f7","873":"bbf13bcf"}[chunkId] + ".chunk.css";
};